import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { translations, LANGS } from './translations';

const I18nContext = createContext(null);

function resolveKey(obj, path) {
  if (!obj) return undefined;
  return path.split('.').reduce((acc, k) => (acc && acc[k] !== undefined ? acc[k] : undefined), obj);
}

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === 'undefined') return 'hu';
    const saved = localStorage.getItem('leadeverest_lang');
    if (saved && translations[saved]) return saved;
    const nav = (navigator.language || 'hu').slice(0, 2).toLowerCase();
    return translations[nav] ? nav : 'hu';
  });

  const setLang = (code) => {
    if (!translations[code]) return;
    setLangState(code);
    try { localStorage.setItem('leadeverest_lang', code); } catch (_) {}
  };

  useEffect(() => {
    if (typeof document !== 'undefined') document.documentElement.lang = lang;
  }, [lang]);

  const value = useMemo(() => {
    const t = (path, fallback) => {
      const v = resolveKey(translations[lang], path);
      if (v !== undefined) return v;
      const f = resolveKey(translations.hu, path);
      return f !== undefined ? f : (fallback !== undefined ? fallback : path);
    };
    return { lang, setLang, t, langs: LANGS };
  }, [lang]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error('useI18n must be used within I18nProvider');
  return ctx;
}

export function useT() {
  return useI18n().t;
}
